exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".activity-items[data-v-28aef7c4]{height:450px;overflow-y:auto}", ""]);

// exports
